import React from 'react'

const SelectInput = React.forwardRef((props, ref) => (
  <label className='team-label league-label'>
    {props.label}
    <select className='team-control league-control' {...props} ref={ref}>
      { props.options.map((o, i) => {
        const value = Array.isArray(o) ? o[0] : o
        const label = Array.isArray(o) ? o[1] : o
        return <option key={i} value={value}>{label}</option>
      })}
    </select>
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default SelectInput
